// RUTA: src/pages/MaestroEnvasesPage.tsx

import React, { useState } from 'react';
import styled from 'styled-components';
import ExpandingCard from '../components/common/ExpandingCard';
import { cardData } from '../components/common/cardData';

const PageWrapper = styled.div`
  padding: 40px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 32px;
  
  /* ✅ ESTA LÍNEA ES LA CLAVE DE TODO:
     Evita que los elementos de la cuadrícula se estiren para igualar su altura. */
  align-items: start;
`;

const MaestroEnvasesPage: React.FC = () => {
  const [expandedCardId, setExpandedCardId] = useState<string | null>(null);

  const handleMouseEnter = (cardId: string) => {
    setExpandedCardId(cardId);
  };

  const handleMouseLeave = () => {
    setExpandedCardId(null);
  };

  return (
    <PageWrapper>
      {cardData.map((card) => (
        <ExpandingCard
          key={card.id}
          cardInfo={card}
          isExpanded={expandedCardId === card.id}
          onMouseEnter={() => handleMouseEnter(card.id)}
          onMouseLeave={handleMouseLeave}
        />
      ))}
    </PageWrapper>
  );
};

export default MaestroEnvasesPage;